import React, { useState, useEffect, useContext, useRef } from 'react';

import styles from 'components/layout_and_quote_builder/_style.module.scss';
import LayoutNavSectionCombination from 'components/layout_and_quote_builder/LayoutNavSectionCombination.jsx';

// `selected` (optional) draws a brand outline around the card -- used by the guided setup wizard to show
// which solution card is currently marked. It is an OUTLINE, not a border, so it adds no box and cannot
// disturb the flex `flex: 0 0 25%` card sizing. Absent everywhere else, so those cards are unchanged.
// `columnBasis` (optional) overrides that 25% flex basis -- the wizard passes a wider one (33.333%) so its
// narrower modal shows 3 cards per row instead of 4. Absent -> the .combinations_grid_item_cont 25% stands.
// `dimmed` (optional) fades the card to 0.8 opacity -- the Solution tab dims the un-selected solutions so the
// selected one stands out. Absent everywhere else.
// `selectButton` (optional) renders an explicit "Select" button at the bottom of the card, so it is obvious the
// whole card is a choice (the card is clickable, but that affordance is easy to miss). Frank's /mcc passes it;
// absent everywhere else, so those cards are unchanged. selectLabel / selectedLabel are the button's text in the
// two states (the caller passes the translated strings).
// `nextButton` (optional) adds a "Next" button UNDER the Select button, shown only once THIS card is `selected`.
// It calls `onNext` -- Frank's /mcc Solution tab passes the page's advance-one-stage callback (on to Pricing),
// so a user who has marked a solution can move on without hunting for the numbered stage tab. Absent (and off
// the guided setup wizard, which has its own Next) everywhere else. nextLabel is the button's translated text.
const LayoutNavSectionCombinationListList = ({
  list, count, setSelectedList, selected = false, columnBasis = null, dimmed = false,
  selectButton = false, selectLabel = 'Select', selectedLabel = 'Selected',
  nextButton = false, nextLabel = 'Next', onNext = null,
}) => {
  const [totalScore, setTotalScore] = useState(0)
  const [totalScoreList, setTotalScoreList] = useState({})
  const [numTotals, setNumTotals] = useState( {} )
  const [numTotalsPrinting, setNumTotalsPrinting] = useState( {} )
  const [numOfDrawingsInSet, setNumOfDrawingsInSet] = useState( {} )

  const handleClick = () => {
    setSelectedList( list )
  }

  const showNavSectionCombination = ( result, index ) => {
    return <LayoutNavSectionCombination
      index = {index}
      diecutting_result={result.diecutting_result}
      nav_section_id={result.nav_section_id}
      count={count}
      layout_dimension={result.material_layout_dimension}
      setTotalScoreList={setTotalScoreList}
      setNumTotals={setNumTotals}
      setNumTotalsPrinting={setNumTotalsPrinting}
      setNumOfDrawingsInSet={setNumOfDrawingsInSet}
    />
  }

  useEffect( () => {
    for(let i = 0; i < list.length; i++ ) {
      list[i].num_total_diecutting = numTotals[i]
      list[i].num_total_printing   = numTotalsPrinting[i]
    }
  }, [numTotals, numTotalsPrinting] )


  useEffect( () => {
    setTotalScore( () => Object.values(totalScoreList).reduce((a, b) => a + b, 0)  )
  }, [totalScoreList])

  useEffect( () => {
    for(let i = 0; i < list.length; i++ ) {
      list[i].num_of_drawings_in_set = numOfDrawingsInSet[i]
    }
  }, [numOfDrawingsInSet] )

  return (
    <div
      className={styles.combinations_grid_item_cont}
      key={name}
      data-score={totalScore}
      // The one card a stage tab scrolls to when it opens (ManufacturingLineLists' #scrollToSelectedCard). It
      // marks what `selected` already means, so nothing new is passed in and a caller that does not use
      // `selected` -- the legacy page -- has no attribute at all.
      data-selected-card={selected ? true : undefined}
      onClick={handleClick}
      style={{
        ...(columnBasis ? { flex: `0 0 ${columnBasis}`, maxWidth: columnBasis } : {}),
        ...(selected ? { outline: '3px solid var(--brand, #eb5424)', outlineOffset: '-3px' } : {}),
        ...(dimmed ? { opacity: 0.8 } : {}),
      }}
    >
      <div className={styles.card_top_bar}>
        <div style={{fontSize: '12px' }} className="stars-rating-container"></div>
      </div>

      {list.map((result, index) => (
        <React.Fragment key={index}>
          {showNavSectionCombination(result, index)}
        </React.Fragment>
      ))}

      {/* The explicit Select button. Does the same as clicking the card (handleClick); stopPropagation keeps the
          card's own onClick from ALSO firing, which -- since the click TOGGLES the mark -- would undo it. */}
      {selectButton && (
        <button
          type="button"
          data-frank-select-solution
          className={`dct-button dct-button--small dct-button--block ${selected ? 'dct-button--primary' : 'dct-button--secondary'}`}
          style={{ marginTop: '8px' }}
          onClick={(event) => { event.stopPropagation(); handleClick(); }}
        >
          {selected ? selectedLabel : selectLabel}
        </button>
      )}

      {/* The "Next" button, shown only once this card is the selected solution. It moves the page on to the next
          stage (Pricing) via onNext; stopPropagation keeps the card's own onClick (which toggles the mark) from
          also firing and un-marking the card the user is trying to move on from. */}
      {nextButton && selected && onNext && (
        <button
          type="button"
          data-frank-next-stage
          className="dct-button dct-button--small dct-button--block dct-button--primary"
          style={{ marginTop: '8px' }}
          onClick={(event) => { event.stopPropagation(); onNext(); }}
        >
          {nextLabel}
        </button>
      )}
    </div>
  )
}

export default LayoutNavSectionCombinationListList;
